import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <Container fluid>
          <Row>
            <Col xs="12" sm="3">
              <div className="footer-social">
                <a href="https://twitter.com/alta_global">
                  <i className="fa fa-twitter" />
                </a>
                <a href="https://www.linkedin.com/company/alta-ventures-mexico/">
                  <i className="fa fa-linkedin" />
                </a>
              </div>
            </Col>
            <Col xs="12" sm="6">
              <div className="footer-links">
                <a href="/">Home</a> <a href="/team/">Team</a>{" "}
                <a href="/portfolio/">Portfolio</a>{" "}
                <a href="/#contact">Contact</a>
              </div>
            </Col>
            <Col xs="12" sm="3">
              &nbsp;
            </Col>
          </Row>
        </Container>
        <div className="notice-container">
          <div className="footer-copy-sm">
            Copyright © 2023 Alta Global Ventures
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer/index.js